import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/Layout.jsx'
import Leads from './pages/Leads.jsx'
import FollowUps from './pages/FollowUps.jsx'
import Companies from './pages/Companies.jsx'
import Operations from './pages/Operations.jsx'
import OperationDetail from './pages/OperationDetail.jsx'
import CstScores from './pages/CstScores.jsx'
import Settings from './pages/Settings.jsx'
import RegistrationSurvey from './pages/RegistrationSurvey.jsx'
import CstSurvey from './pages/CstSurvey.jsx'
import HrReport from './pages/HrReport.jsx'
import BotInbox from './pages/BotInbox'

export default function App() {
  return (
    <Routes>
      {/* Public, unauthenticated routes — rendered without the Layout/sidebar */}
      <Route path="/survey/registration/:token" element={<RegistrationSurvey />} />
      <Route path="/survey/cst/:token"          element={<CstSurvey />} />
      <Route path="/survey/report/:token"       element={<HrReport />} />

      <Route element={<Layout />}>
        <Route path="/"                       element={<Navigate to="/leads" replace />} />
        <Route path="/inbox"                  element={<Navigate to="/leads" replace />} />
        <Route path="/leads"                  element={<Leads />} />
        <Route path="/follow-ups"             element={<FollowUps />} />
        <Route path="/companies"              element={<Companies />} />
        <Route path="/operations"             element={<Operations />} />
        <Route path="/operations/:id"         element={<OperationDetail />} />
        <Route path="/operations/:id/:tab"    element={<OperationDetail />} />
        <Route path="/cst"                    element={<CstScores />} />
        <Route path="/bot"                    element={<BotInbox />} />
        <Route path="/settings"               element={<Settings />} />
        <Route path="*" element={<div className="p-8 text-slate-500">Not found.</div>} />
      </Route>
    </Routes>
  )
}
